export default "__VITE_ASSET__CAjq06x3__"